import styled from 'styled-components';

export const FlagsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const FlagButton = styled.button`
  width: 32px;
  height: 22px;
  border: 2px solid
    ${(props) =>
      props.$variant === "dark"
        ? props.isActive
          ? "#25d07f"
          : "transparent"
        : props.isActive
          ? "#2d5016"
          : "transparent"};
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;
  box-shadow: ${(props) =>
    props.$variant === "dark"
      ? props.isActive
        ? "0 2px 10px rgba(37, 208, 127, 0.35)"
        : "0 1px 4px rgba(0, 0, 0, 0.35)"
      : props.isActive
        ? "0 2px 6px rgba(45, 80, 22, 0.3)"
        : "0 1px 3px rgba(0, 0, 0, 0.2)"};
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${(props) =>
      props.$variant === "dark"
        ? props.isActive
          ? "0 3px 12px rgba(37, 208, 127, 0.45)"
          : "0 2px 8px rgba(0, 0, 0, 0.4)"
        : props.isActive
          ? "0 3px 8px rgba(45, 80, 22, 0.4)"
          : "0 2px 6px rgba(0, 0, 0, 0.3)"};
    border-color: ${(props) =>
      props.$variant === "dark"
        ? props.isActive
          ? "#25d07f"
          : "rgba(169, 192, 204, 0.5)"
        : props.isActive
          ? "#2d5016"
          : "#999"};
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  @media (max-width: 768px) {
    width: 28px;
    height: 19px;
  }
`;

